import { Alert } from 'antd';
import React from 'react';

const ResellerTrialBanner: React.FC = () => {
	return (
		<Alert
			message={<strong className="text-base md:text-lg font-medium">Trial Call Limit</strong>}
			description={
				<p className="text-sm md:text-base m-0 text-gray-700 font-normal">
					You get 15 free test calls with your trial account. When you're ready to go live, simply
					upgrade to a paid plan to start using the AI receptionist for your business.
				</p>
			}
			type="warning"
			showIcon
			className="mb-4"
		/>
	);
};

export default ResellerTrialBanner;
